<template>
  <div class="">
    <h2 class="text-lg font-normal">Departments list</h2>
    <div class="flex flex-wrap mt-4 -mx-2">
      <div
        v-for="(department, index) of departments"
        :key="index"
        class="md:w-1/3 px-2"
      >
        <NuxtLink
          class="card p-4 md:mb-4 font-semibold ui-font"
          :to="`/departments/${encodeURIComponent(department.id)}/overview`"
        >
          {{ department.displayName }}
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('departments', {
      departments: (state) => state.chosen || state.all,
    }),
  },
}
</script>
